/*@jsxRuntime automatic @jsxImportSource react*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1787097600000), keywords = "insufficient_access_or_readonly, INSUFFICIENT_ACCESS_OR_READONLY, INSUFFICIENT_ACCESS_ON_CROSS_REFERENCE_ENTITY, read-only";
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Wed Aug 19 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "salesforce",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Overview",
          "depth": 0,
          "id": "overview"
        }, {
          "value": "Supported syncing",
          "depth": 0,
          "id": "supported-syncing"
        }, {
          "value": "Understand your Salesforce setup",
          "depth": 0,
          "id": "understand-your-salesforce-setup"
        }, {
          "value": "Required data specifications",
          "depth": 1,
          "id": "required-data-specifications"
        }, {
          "value": "Other considerations",
          "depth": 1,
          "id": "other-considerations"
        }, {
          "value": "Inspect objects, relationships, and fields",
          "depth": 1,
          "id": "inspect-objects-relationships-and-fields"
        }, {
          "value": "Inspect APEX triggers and flows",
          "depth": 1,
          "id": "inspect-apex-triggers-and-flows"
        }, {
          "value": "Connect to Salesforce",
          "depth": 0,
          "id": "connect-to-salesforce"
        }, {
          "value": "Sync configuration",
          "depth": 0,
          "id": "sync-configuration"
        }, {
          "value": "Objects",
          "depth": 1,
          "id": "objects"
        }, {
          "value": "Custom picklist values",
          "depth": 1,
          "id": "custom-picklist-values"
        }, {
          "value": "Platform events",
          "depth": 1,
          "id": "platform-events"
        }, {
          "value": "Tips and troubleshooting",
          "depth": 0,
          "id": "tips-and-troubleshooting"
        }, {
          "value": "Behavior and limitations",
          "depth": 1,
          "id": "behavior-and-limitations"
        }, {
          "value": "Sync volume and performance",
          "depth": 1,
          "id": "sync-volume-and-performance"
        }, {
          "value": "Validate your setup",
          "depth": 1,
          "id": "validate-your-setup"
        }, {
          "value": "Common errors",
          "depth": 1,
          "id": "common-errors"
        }, {
          "value": "Missing or non-updating fields in sync configuration",
          "depth": 1,
          "id": "missing-or-non-updating-fields-in-sync-configuration"
        }, {
          "value": "Duplicate records in Salesforce",
          "depth": 1,
          "id": "duplicate-records-in-salesforce"
        }, {
          "value": "Live debugger",
          "depth": 1,
          "id": "live-debugger"
        }, {
          "value": "Sync alerts",
          "depth": 1,
          "id": "sync-alerts"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      p: "p",
      ul: "ul",
      li: "li",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td",
      a: "a",
      strong: "strong",
      h3: "h3",
      img: "img",
      ol: "ol",
      h4: "h4",
      code: "code",
      em: "em",
      pre: "pre",
      span: "span"
    }, _provideComponents(), props.components), {DownloadLink, EventSyncWarning, CommonErrorsPreface, LiveDebugger, SyncAlerts} = _components;
    if (!CommonErrorsPreface) _missingMdxReference("CommonErrorsPreface", true);
    if (!DownloadLink) _missingMdxReference("DownloadLink", true);
    if (!EventSyncWarning) _missingMdxReference("EventSyncWarning", true);
    if (!LiveDebugger) _missingMdxReference("LiveDebugger", true);
    if (!SyncAlerts) _missingMdxReference("SyncAlerts", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        id: "overview",
        children: "Overview"
      }), "\n", _jsx(_components.p, {
        children: "Salesforce is a CRM platform. Use Hightouch to sync records to standard and custom Salesforce objects, sync custom picklist metadata, and publish platform events so Salesforce can trigger automation from warehouse data."
      }), "\n", _jsx(_components.p, {
        children: "The destination supports:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Sales Cloud"
        }), "\n", _jsx(_components.li, {
          children: "Service Cloud"
        }), "\n", _jsx(_components.li, {
          children: "Financial Services Cloud"
        }), "\n", _jsx(_components.li, {
          children: "Health Cloud"
        }), "\n"]
      }), "\n", _jsx(_components.h2, {
        id: "supported-syncing",
        children: "Supported syncing"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Sync Type"
            }), _jsx(_components.th, {
              children: "Description"
            }), _jsx(_components.th, {
              children: "Supported Sync Modes"
            }), _jsx(_components.th, {
              children: "API Reference"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "#objects",
                children: _jsx(_components.strong, {
                  children: "Standard and custom objects"
                })
              })
            }), _jsx(_components.td, {
              children: "Sync records to Salesforce objects such as accounts, contacts or custom objects"
            }), _jsx(_components.td, {
              children: "Insert, Update, Upsert, Archive"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://developer.salesforce.com/docs/atlas.en-us.object_reference.meta/object_reference/sforce_api_objects_list.htm",
                children: "Manage object records ↗"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "#custom-picklist-values",
                children: _jsx(_components.strong, {
                  children: "Metadata for picklist fields"
                })
              })
            }), _jsx(_components.td, {
              children: "Sync metadata to your Salesforce Picklist fields."
            }), _jsx(_components.td, {
              children: "All"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://developer.salesforce.com/docs/atlas.en-us.api_meta.meta/api_meta/meta_field_types.htm",
                children: "Update metadata field types ↗"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "#platform-events",
                children: _jsx(_components.strong, {
                  children: "Platform events"
                })
              })
            }), _jsx(_components.td, {
              children: "Publish event messages that can be received by Salesforce flows, processes, Apex triggers, and more."
            }), _jsx(_components.td, {
              children: "Insert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://developer.salesforce.com/docs/atlas.en-us.platform_events.meta/platform_events/platform_events_intro.htm",
                children: "Publish platform events ↗"
              })
            })]
          })]
        })]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Insert"
          }), ": Insert mode pushes new objects or events to Salesforce and doesn't update them as they change in your data source. Insert is the only available mode for platform events."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Update"
          }), ": Update mode updates fields on existing objects in Salesforce."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Upsert"
          }), ": Upsert mode pushes new objects to Salesforce and updates fields that change in your data source."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Archive"
          }), ": Archive mode ", _jsx(_components.a, {
            href: "https://developer.salesforce.com/docs/atlas.en-us.api_rest.meta/api_rest/dome_delete_record.htm",
            children: "deletes"
          }), " all records that appear in your model's query results."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "All"
          }), ": All mode is the only available mode for metadata for picklists. Each time you sync metadata values for a particular picklist, it overwrites all existing values."]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["For more information about sync modes, refer to the ", _jsx(_components.a, {
          href: "/syncs/types-and-modes#sync-modes",
          children: "sync modes"
        }), " docs."]
      }), "\n", _jsx(_components.h2, {
        id: "understand-your-salesforce-setup",
        children: "Understand your Salesforce setup"
      }), "\n", _jsxs(_components.p, {
        children: ["Before you configure syncs, confirm your Salesforce setup supports your plan. Whether the matching field is an external ID and unique, whether target fields are editable (not formula or read-only), and whether the authenticating user has edit access all determine whether a sync works. For the planning steps common to every destination (what to sync, which fields, which mode, and how often), see ", _jsx(_components.a, {
          href: "/destinations/overview#plan-your-sync",
          children: "Plan your sync"
        }), ". If you prefer, you can ", _jsx(DownloadLink, {
          href: "https://cdn.sanity.io/files/pwmfmi47/production/2545813fbdd7a7e37f5cfff384544f07484754ec.pdf",
          fileName: "Salesforce Sync Configuration Considerations",
          children: "download this resource as a PDF"
        }), " to share with your team."]
      }), "\n", _jsxs(_components.p, {
        children: ["To learn what objects and fields you are using in your Salesforce instance, you can ", _jsx(_components.a, {
          href: "#inspect-objects-relationships-and-fields",
          children: "inspect your Object Manager"
        }), "."]
      }), "\n", _jsx(_components.h3, {
        id: "required-data-specifications",
        children: "Required data specifications"
      }), "\n", _jsxs(_components.p, {
        children: ["Once you've confirmed the objects and fields you want to sync, you need to check that they have the correct data types and that you have permission to edit them. You can find the answers to these questions by ", _jsx(_components.a, {
          href: "#inspect-objects-relationships-and-fields",
          children: "using the Object Manager in Salesforce"
        }), "."]
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: _jsx("div", {
                style: {
                  width: "250px"
                },
                children: "Consideration"
              })
            }), _jsx(_components.th, {
              children: "Effect on sync configuration"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsxs(_components.td, {
              children: ["Is the field that you would like to use for ", _jsx(_components.a, {
                href: "#record-matching",
                children: "record matching"
              }), " an ", _jsx(_components.a, {
                href: "https://help.salesforce.com/articleView?id=inserting_updating_or_deleting_data.htm&type=5",
                children: _jsx(_components.strong, {
                  children: "external ID"
                })
              }), " and ", _jsx(_components.a, {
                href: "https://help.salesforce.com/s/articleView?id=000385174&language=en_US&type=1",
                children: _jsx(_components.strong, {
                  children: "unique"
                })
              }), "?"]
            }), _jsxs(_components.td, {
              children: ["The response affects your ", _jsx(_components.a, {
                href: "#record-matching",
                children: "record matching"
              }), "; only fields that meet this criteria appear in the dropdown for record matching."]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "What are the expected data types of the fields you want to sync to?"
            }), _jsxs(_components.td, {
              children: ["The response affects your ", _jsx(_components.a, {
                href: "#field-mapping",
                children: "field mapping"
              }), "; if the expected type is different than your model column type, you need to ", _jsx(_components.a, {
                href: "/models/data-types-casting",
                children: "type cast your data"
              }), " in your model configuration."]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Are the fields you want to sync to editable?"
            }), _jsxs(_components.td, {
              children: ["Hightouch only displays editable fields during ", _jsx(_components.a, {
                href: "#field-mapping",
                children: "field mapping"
              }), "."]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Does the user you are authenticating to Hightouch have edit access?"
            }), _jsx(_components.td, {
              children: "The sync will error if the user doesn't have the correct permissions."
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Are any of the data fields lookup fields to another Salesforce object"
            }), _jsxs(_components.td, {
              children: ["You can set up ", _jsx(_components.a, {
                href: "#relationships-object-id-lookup",
                children: "Lookup fields"
              }), " while field mapping."]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Are any of the data fields formula fields?"
            }), _jsx(_components.td, {
              children: "Formula fields are non-editable and read-only, so the sync will throw an error; change the field type if you want to sync data to it."
            })]
          })]
        })]
      }), "\n", _jsx(_components.h3, {
        id: "other-considerations",
        children: "Other considerations"
      }), "\n", _jsx(_components.p, {
        children: "These last considerations examine the wider context of your Salesforce instance to ensure that your sync won't conflict with other Salesforce automations or overuse your API call quota."
      }), "\n", _jsxs(_components.p, {
        children: ["You can ", _jsx(_components.a, {
          href: "#inspect-apex-triggers-and-flows",
          children: "inspect an objects' triggers and flows"
        }), " using the Object Manager. You can inspect your API usage and quota by going to ", _jsx(_components.strong, {
          children: "Setup → Environments → System Overview"
        }), ", or by checking Salesforce's ", _jsx(_components.a, {
          href: "https://developer.salesforce.com/docs/atlas.en-us.salesforce_app_limits_cheatsheet.meta/salesforce_app_limits_cheatsheet/salesforce_app_limits_platform_api.htm",
          children: "quick reference"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-salesforce-api-usage.png",
          alt: "Salesforce API usage"
        })
      }), "\n", _jsx(_components.p, {
        children: "Refer to your Salesforce contract in case of any custom limits."
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: _jsx("div", {
                style: {
                  width: "250px"
                },
                children: "Consideration"
              })
            }), _jsx(_components.th, {
              children: "Effect on sync configuration"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "What Salesforce workflows or APEX triggers are you running? What objects do they touch, when do they run?"
            }), _jsxs(_components.td, {
              children: ["The response affects your ", _jsx(_components.a, {
                href: "/syncs/schedule-sync-ui",
                children: "sync schedule"
              }), "; syncs will error if there are conflicting processes."]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "What Salesforce plan do you have and what are your API limits?"
            }), _jsxs(_components.td, {
              children: ["The response affects your ", _jsx(_components.a, {
                href: "/syncs/schedule-sync-ui",
                children: "sync schedule"
              }), "; syncs will error if you use up your API call quota."]
            })]
          })]
        })]
      }), "\n", _jsx(_components.h3, {
        id: "inspect-objects-relationships-and-fields",
        children: "Inspect objects, relationships, and fields"
      }), "\n", _jsxs(_components.ol, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Login to your Salesforce instance and make sure you are in the ", _jsx(_components.strong, {
              children: "Sales"
            }), " module."]
          }), "\n", _jsx(_components.p, {
            children: _jsx(_components.img, {
              src: "destinations/destination-salesforce-sales-module.png",
              alt: "Screenshot of Salesforce Sales module homepage"
            })
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Click the gear icon in the top right and open the ", _jsx(_components.strong, {
              children: "Setup"
            }), " page."]
          }), "\n", _jsx(_components.p, {
            children: _jsx(_components.img, {
              src: "destinations/destination-salesforce-setup.png",
              alt: "Screenshot of Salesforce Sales module homepage"
            })
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Search for ", _jsx(_components.strong, {
              children: "Object Manager"
            }), " in the left search input and open it."]
          }), "\n", _jsx(_components.p, {
            children: _jsx(_components.img, {
              src: "destinations/destination-salesforce-object-manager.png",
              alt: "Search for Object Manager"
            })
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Search for the object you are interested in syncing to the ", _jsx(_components.strong, {
              children: "Quick find"
            }), " input, for example ", _jsx(_components.strong, {
              children: "Contact"
            }), ". Click the label name to inspect the object."]
          }), "\n", _jsx(_components.p, {
            children: _jsx(_components.img, {
              src: "destinations/destination-salesforce-contact-object.png",
              alt: "Search for objects in the Object Manager"
            })
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["From the left sidebar, click ", _jsx(_components.strong, {
              children: "Fields & Relationships"
            }), ". Inspect the field names and data types to confirm which you plan to sync via Hightouch. Any fields you want to use for ", _jsx(_components.a, {
              href: "#record-matching",
              children: "record matching"
            }), " must have the ", _jsx(_components.strong, {
              children: "External ID"
            }), " and ", _jsx(_components.strong, {
              children: "Unique"
            }), " types."]
          }), "\n", _jsx(_components.p, {
            children: _jsx(_components.img, {
              src: "destinations/destination-salesforce-inspect-fields.png",
              alt: "Inspect fields and relationships in the Object Manager"
            })
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["If necessary, ", _jsx(_components.strong, {
              children: "create a new custom field"
            }), " and set it's type to Unique and an External ID."]
          }), "\n", _jsxs(_components.ul, {
            children: ["\n", _jsxs(_components.li, {
              children: ["Click ", _jsx(_components.strong, {
                children: "New"
              }), " in your chosen object's ", _jsx(_components.strong, {
                children: "Fields & Relationships"
              }), "."]
            }), "\n"]
          }), "\n", _jsx(_components.p, {
            children: _jsx(_components.img, {
              src: "destinations/destination-salesforce-new-field.png",
              alt: "Click on the \"New\" button in your chosen object"
            })
          }), "\n", _jsxs(_components.ul, {
            children: ["\n", _jsxs(_components.li, {
              children: ["Choose the field type, for example ", _jsx(_components.strong, {
                children: "Email"
              }), " or ", _jsx(_components.strong, {
                children: "Text"
              }), ", then click ", _jsx(_components.strong, {
                children: "Next"
              }), ". (You'll set the Unique and an External ID types in the next step.)"]
            }), "\n"]
          }), "\n", _jsx(_components.p, {
            children: _jsx(_components.img, {
              src: "destinations/destination-salesforce-select-field-type.png",
              alt: "Choose the field type you want to use"
            })
          }), "\n", _jsxs(_components.ul, {
            children: ["\n", _jsxs(_components.li, {
              children: ["Give your new field a ", _jsx(_components.strong, {
                children: "Field Label"
              }), " and description. Enable the ", _jsx(_components.strong, {
                children: "Unique"
              }), " and ", _jsx(_components.strong, {
                children: "External ID"
              }), " checkboxes. Click ", _jsx(_components.strong, {
                children: "Next"
              }), "."]
            }), "\n"]
          }), "\n", _jsx(_components.p, {
            children: _jsx(_components.img, {
              src: "destinations/destination-salesforce-external-id.png",
              alt: "Select the 2 required options as shown"
            })
          }), "\n", _jsxs(_components.ul, {
            children: ["\n", _jsxs(_components.li, {
              children: ["\n", _jsxs(_components.p, {
                children: ["Select the profiles to which you want to grant edit access to this field via field-level security. The field will be hidden from all profiles if you don't add it to field-level security. Click ", _jsx(_components.strong, {
                  children: "Next"
                }), "."]
              }), "\n"]
            }), "\n", _jsxs(_components.li, {
              children: ["\n", _jsxs(_components.p, {
                children: ["Add the field to the page layouts you like and click ", _jsx(_components.strong, {
                  children: "Save"
                }), "."]
              }), "\n"]
            }), "\n"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsx(_components.h3, {
        id: "inspect-apex-triggers-and-flows",
        children: "Inspect APEX triggers and flows"
      }), "\n", _jsxs(_components.ol, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Login to your Salesforce instance and make sure you are in the ", _jsx(_components.strong, {
              children: "Sales"
            }), " module."]
          }), "\n", _jsx(_components.p, {
            children: _jsx(_components.img, {
              src: "destinations/destination-salesforce-sales-module.png",
              alt: "Screenshot of Salesforce Sales module homepage"
            })
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Click the gear icon in the top right and open the ", _jsx(_components.strong, {
              children: "Setup"
            }), " page."]
          }), "\n", _jsx(_components.p, {
            children: _jsx(_components.img, {
              src: "destinations/destination-salesforce-setup.png",
              alt: "Screenshot of Salesforce Sales module homepage"
            })
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Search for ", _jsx(_components.strong, {
              children: "Object Manager"
            }), " in the left search input and open it."]
          }), "\n", _jsx(_components.p, {
            children: _jsx(_components.img, {
              src: "destinations/destination-salesforce-object-manager.png",
              alt: "Search for Object Manager"
            })
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Select the object you want to inspect the APEX triggers and workflows for, for example ", _jsx(_components.strong, {
              children: "Contact"
            }), ". Click the object to open its detail page."]
          }), "\n", _jsx(_components.p, {
            children: _jsx(_components.img, {
              src: "destinations/destination-salesforce-contact-object.png",
              alt: "Search for objects in the Object Manager"
            })
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["From the left sidebar, click ", _jsx(_components.strong, {
              children: "Triggers"
            }), " or ", _jsx(_components.strong, {
              children: "Flow Triggers"
            }), ", depending on which one you want to inspect first."]
          }), "\n", _jsx(_components.p, {
            children: _jsx(_components.img, {
              src: "destinations/destination-salesforce-triggers.png",
              alt: "Object Triggers"
            })
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "The Triggers page displays a list of all the APEX triggers that are associated with the object. To inspect a specific trigger, click its name."
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "The Flow Triggers page displays list of all the workflows that are associated with the object. To inspect a specific flow, click its name."
          }), "\n", _jsx(_components.p, {
            children: _jsx(_components.img, {
              src: "destinations/destination-salesforce-triggers-2.png",
              alt: "Object Triggers"
            })
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.ol, {
        start: "6",
        children: ["\n", _jsx(_components.li, {
          children: "Once you've opened a specific workflow or trigger, you can inspect its properties, such as its name, status, and other details.\nYou can also edit or delete the workflow or trigger from this page, as well as view the history of changes made to it, if you have the correct permissions."
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["If you have any triggers or flows on objects you plan on syncing to, make sure to ", _jsx(_components.a, {
          href: "/syncs/schedule-sync-ui",
          children: "schedule your Hightouch syncs"
        }), " so as to not conflict with them."]
      }), "\n", _jsx(_components.h2, {
        id: "connect-to-salesforce",
        children: "Connect to Salesforce"
      }), "\n", _jsx(_components.p, {
        children: "Authenticate the Salesforce destination via OAuth."
      }), "\n", _jsxs(_components.p, {
        children: ["Use a Salesforce user with access to every object and field you plan to sync — the simplest option is a ", _jsx(_components.a, {
          href: "https://www.salesforce.com/blog/what-is-a-salesforce-admin/",
          children: "system administrator"
        }), " or a dedicated ", _jsx(_components.a, {
          href: "https://help.salesforce.com/s/articleView?id=sf.create_sf_user.htm&language=en_US&type=5",
          children: "integration user"
        }), ". That user's profile must have:"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Read and write access to every object and field you intend to sync."
        }), "\n", _jsxs(_components.li, {
          children: ["The ", _jsx(_components.strong, {
            children: "View Setup and Configuration"
          }), " permission, under ", _jsx(_components.strong, {
            children: "Administrative Permissions"
          }), "."]
        }), "\n", _jsxs(_components.li, {
          children: ["Delete permission on any object you archive or delete records from (required for ", _jsx(_components.strong, {
            children: "Archive"
          }), " mode and the ", _jsx(_components.strong, {
            children: "Delete record"
          }), " delete behavior)."]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["Select ", _jsx(_components.strong, {
          children: "Log in to Salesforce"
        }), ", sign in with that user, and select ", _jsx(_components.strong, {
          children: "Allow"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-salesforce-authorization-successful.png",
          alt: "Success notification in the Hightouch UI"
        })
      }), "\n", _jsx(Tip, {
        children: _jsx(_components.p, {
          children: "If you have Salesforce Authenticator setup as your 2FA, you may have to accept\nthe request from your device."
        })
      }), "\n", _jsx(_components.h2, {
        id: "sync-configuration",
        children: "Sync configuration"
      }), "\n", _jsx(_components.p, {
        children: "The configuration options below vary by sync type."
      }), "\n", _jsx(_components.h3, {
        id: "objects",
        children: "Objects"
      }), "\n", _jsx(_components.p, {
        children: "When syncing objects, you can choose to insert, update, upsert, or delete (archive) them. Consult the following table to understand which is best for your use case."
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Sync mode"
            }), _jsx(_components.th, {
              children: "Use case"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Insert"
            }), _jsx(_components.td, {
              children: "You want to push objects into Salesforce, but don't care if the data within each object remains up to date."
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Update"
            }), _jsx(_components.td, {
              children: "You have objects in Salesforce that you want to add information to, but you don't want to create any new objects."
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Upsert"
            }), _jsx(_components.td, {
              children: "You want to push objects into Salesforce and want to keep the data up-to-date."
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Archive"
            }), _jsx(_components.td, {
              children: "You have objects in Salesforce you would like to delete and your model contains those records and only those records."
            })]
          })]
        })]
      }), "\n", _jsx(Warning, {
        children: _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Archive"
          }), " mode deletes every Salesforce record returned by your model's\nquery results. It's a destructive delete, not a recoverable archive — use it\nonly when your model is scoped to exactly the records you intend to delete."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "record-matching",
        children: "Record matching"
      }), "\n", _jsx(Warning, {
        children: _jsxs(_components.p, {
          children: ["Because inserts are non-idempotent when using Salesforce ID as an identifier,\nHightouch doesn't support matching on Salesforce ID when upserting. ", _jsx(_components.strong, {
            children: "If you'd\nlike to sync records based on Salesforce ID, use update mode"
          }), "."]
        })
      }), "\n", _jsxs(_components.p, {
        children: ["To match rows from your model to record in Salesforce, you need to select the model column and corresponding Salesforce field. Hightouch requires you use an ", _jsx(_components.a, {
          href: "https://help.salesforce.com/articleView?id=inserting_updating_or_deleting_data.htm&type=5",
          children: _jsx(_components.strong, {
            children: "external ID"
          })
        }), " type field as the field to match on. It should be an explicit external ID type in Salesforce, not just an external ID field by practice."]
      }), "\n", _jsxs(_components.p, {
        children: ["Using an external ID field for matching lets Hightouch use Salesforce's native ", _jsx(_components.a, {
          href: "https://developer.salesforce.com/docs/atlas.en-us.api_rest.meta/api_rest/dome_upsert.htm",
          children: "upsert API"
        }), ", meaning Hightouch doesn't need to perform a search to determine if a record should be updated or inserted. As a result, sync performance improves and avoids inadvertent duplicates."]
      }), "\n", _jsxs(_components.p, {
        children: ["You can create a custom field and set it to the external ID type by following the ", _jsx(_components.a, {
          href: "#inspect-objects-relationships-and-fields",
          children: "steps outlined above"
        }), ". To learn more, check out the ", _jsx(_components.a, {
          href: "https://help.salesforce.com/s/articleView?id=000383278&type=1",
          children: "Salesforce article on externalID field creation"
        }), ". The information regarding audit fields in the Salesforce article doesn't apply."]
      }), "\n", _jsxs(_components.p, {
        children: ["Once you've created the custom field, select ", _jsx(_components.strong, {
          children: "Refresh"
        }), " next to the destination field dropdown to access the newly created field.\nAn explicit external ID field will have ", _jsx(_components.strong, {
          children: "(recommended)"
        }), " written next to its name."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-salesforce-refresh-fields.png",
          alt: "Refresh button in the Hightouch field mapping UI"
        })
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping",
        children: "Field mapping"
      }), "\n", _jsxs(_components.p, {
        children: ["You can map data from any of your model columns to native and custom fields in your Salesforce objects. Ensure the data type of your model column matches the data type of the field you want to sync to in Salesforce. For example, a ", _jsx(_components.a, {
          href: "https://developer.salesforce.com/docs/atlas.en-us.object_reference.meta/object_reference/primitive_data_types.htm",
          children: "string-type"
        }), " Salesforce field like ", _jsx(_components.code, {
          children: "FirstName"
        }), " expects a ", _jsx(_components.a, {
          href: "/models/data-types-casting#data-types",
          children: "string-type"
        }), " model column."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-salesforce-field-mapping.png",
          alt: "Field mapping in the Hightouch UI"
        })
      }), "\n", _jsx(_components.p, {
        children: "Certain Salesforce fields can be set upon record creation but can't be edited on existing records. Since Salesforce rejects updates to fields that can't be edited:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "in Update mode, the field mapping section only lists editable Salesforce fields;"
        }), "\n", _jsx(_components.li, {
          children: "in Upsert mode, you can also map to non-editable Salesforce fields, but Hightouch omits those mappings when updating existing records, to make sure that your sync is successful."
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["To see if a field is editable, check its ", _jsx(_components.a, {
          href: "https://developer.salesforce.com/docs/atlas.en-us.uiapi.meta/uiapi/ui_api_responses_field.htm",
          children: _jsx(_components.code, {
            children: "updateable"
          })
        }), " field property via the Salesforce API. You can check this property by ", _jsx(_components.a, {
          href: "https://help.salesforce.com/s/articleView?id=sf.remoteaccess_oidc_initial_access_token.htm&type=5",
          children: "generating an initial access token"
        }), " and calling the ", _jsx(_components.a, {
          href: "https://developer.salesforce.com/docs/atlas.en-us.api_rest.meta/api_rest/resources_sobject_describe.htm",
          children: "sObject Describe"
        }), " API endpoint. The ", _jsx(_components.code, {
          children: "updateable"
        }), " value is included in Salesforce's API response, as shown in ", _jsx(_components.a, {
          href: "https://developer.salesforce.com/docs/atlas.en-us.api_rest.meta/api_rest/dome_sobject_describe.htm",
          children: "this example"
        }), "."]
      }), "\n", _jsx(Tip, {
        children: _jsxs(_components.p, {
          children: ["When syncing to a ", _jsx(_components.a, {
            href: "https://help.salesforce.com/s/articleView?id=sf.siteforce_data_form_field_types.htm&type=5",
            children: "multi-select\npicklist"
          }), "\ntype field, make sure to sync ", _jsx(_components.code, {
            children: "string"
          }), "-type values containing\nsemicolon-delimited lists, as explained in ", _jsx(_components.a, {
            href: "https://help.salesforce.com/s/articleView?id=sf.picklist_limitations.htm&type=5",
            children: "Salesforce's\ndocumentation"
          }), "."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "relationships-object-id-lookup",
        children: "Relationships (object ID lookup)"
      }), "\n", _jsxs(_components.p, {
        children: ["In Salesforce, you can set up different ", _jsx(_components.a, {
          href: "https://help.salesforce.com/s/articleView?id=sf.overview_of_custom_object_relationships.htm&type=5",
          children: "types of relationships"
        }), " to associate records on a ", _jsx(_components.strong, {
          children: "main object"
        }), " with records on a ", _jsx(_components.strong, {
          children: "linked object"
        }), ".\nUsing Hightouch, you can relate your Salesforce data through ", _jsx(_components.strong, {
          children: "lookup relationships"
        }), ", which associate records by using a foreign key.\nThis relationship type requires you to copy the ", _jsx(_components.a, {
          href: "https://developer.salesforce.com/docs/atlas.en-us.object_reference.meta/object_reference/field_types.htm#i1435616",
          children: "Salesforce ID"
        }), " of the associated record (on the linked object) and insert it in a specific ", _jsx(_components.a, {
          href: "https://developer.salesforce.com/docs/atlas.en-us.object_reference.meta/object_reference/field_types.htm#i1435823",
          children: "reference field"
        }), " in the record you're syncing (on the main object)."]
      }), "\n", _jsxs(_components.p, {
        children: ["This reference field needs to be an ", _jsxs(_components.a, {
          href: "/models/data-types-casting#data-types",
          children: [_jsx(_components.strong, {
            children: "associated field"
          }), " data type"]
        }), ", which corresponds to Salesforce's ", _jsxs(_components.a, {
          href: "https://help.salesforce.com/s/articleView?id=sf.external_object_lookup_relationships.htm&type=5",
          children: [_jsx(_components.strong, {
            children: "lookup"
          }), " type"]
        }), ".\nYou can confirm the field is a lookup data type in Salesforce by ", _jsx(_components.a, {
          href: "#inspect-objects-relationships-and-fields",
          children: "using the Object Manager"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-salesforce-lookup-type.png",
          alt: "Lookup data type in the Salesforce UI"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["For example, you may want to associate contacts you're updating with their respective Salesforce accounts.\nIn this case, the ", _jsx(_components.strong, {
          children: "Contact"
        }), " object is the main object and the ", _jsx(_components.strong, {
          children: "Account"
        }), " object is the linked object."]
      }), "\n", _jsxs(_components.p, {
        children: ["Records on the ", _jsx(_components.strong, {
          children: "Contact"
        }), " object have an ", _jsxs(_components.a, {
          href: "https://developer.salesforce.com/docs/atlas.en-us.object_reference.meta/object_reference/sforce_api_objects_contact.htm",
          children: [_jsx(_components.code, {
            children: "AccountId"
          }), " field"]
        }), " which expects the Salesforce ID of the related records on the ", _jsx(_components.strong, {
          children: "Account"
        }), " object.\nHowever, your data model might not contain the required Salesforce ID values.\nAs a workaround, perform an ", _jsx(_components.strong, {
          children: "Object ID lookup"
        }), " by:"]
      }), "\n", _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "looking up the Account object based on another unique Salesforce field,"
        }), "\n", _jsx(_components.li, {
          children: "retrieving the Salesforce ID of the associated record on the Account object,"
        }), "\n", _jsxs(_components.li, {
          children: ["syncing that value to the ", _jsx(_components.code, {
            children: "AccountId"
          }), " field on the Contact object."]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["Make sure to use a unique Salesforce field for the lookup.\nIf you already created a separate sync to the linked object, you can select the Salesforce field used for ", _jsx(_components.a, {
          href: "#record-matching",
          children: "record matching"
        }), " in that sync."]
      }), "\n", _jsx(Tip, {
        children: _jsxs(_components.p, {
          children: ["If your source data already contains the required Salesforce ID values, you\ncan skip the lookup by selecting the ", _jsx(_components.strong, {
            children: "Salesforce ID"
          }), " field in the\nrelationship mapping. This will also increase your sync performance."]
        })
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["Make sure that the sync to the linked object always runs before the one to the\nmain object. After creating your syncs, you can ", _jsx(_components.a, {
            href: "/syncs/schedule-sync-with-sequences",
            children: "set up a\nsequence"
          }), " to schedule them in the correct\norder."]
        })
      }), "\n", _jsx(_components.p, {
        children: "In your sync configuration, start by selecting the Salesforce reference field you want to sync to.\nThe left side of the mapper displays the text and inputs:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "find [linked object]"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "where [Salesforce field to use for lookup]"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "equals [model column to match on]"
          })
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-salesforce-object-id-lookup-1.png",
          alt: "Object ID lookup in the Hightouch UI"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["You then need to select the Salesforce field and model column to match on.\nIn this example, Hightouch looks up the corresponding record on the ", _jsx(_components.strong, {
          children: "Account"
        }), " object by matching the value in the ", _jsx(_components.code, {
          children: "unique_key"
        }), " model column to the values in the ", _jsx(_components.code, {
          children: "Unique_Key__c"
        }), " Salesforce field.\nThe lookup returns the associated Salesforce ID, which Hightouch syncs to the ", _jsx(_components.code, {
          children: "AccountId"
        }), " field on the ", _jsx(_components.strong, {
          children: "Contact"
        }), " object."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-salesforce-object-id-lookup-2.png",
          alt: "Object ID lookup in the Hightouch UI"
        })
      }), "\n", _jsx(Tip, {
        children: _jsxs(_components.p, {
          children: ["You can set up a lookup relationship between records on the same object, such\nas relating two records on the ", _jsx(_components.strong, {
            children: "Account"
          }), " object by mapping the ", _jsxs(_components.a, {
            href: "https://developer.salesforce.com/docs/atlas.en-us.object_reference.meta/object_reference/sforce_api_objects_account.htm",
            children: [_jsx(_components.code, {
              children: "ParentId"
            }), "\nlookup\nfield"]
          }), "."]
        })
      }), "\n", _jsxs(_components.p, {
        children: ["You can narrow a lookup by adding ", _jsx(_components.strong, {
          children: "conditions"
        }), " that the matched record must also satisfy.\nFor example, when syncing to the ", _jsx(_components.code, {
          children: "OwnerId"
        }), " field by looking up the ", _jsx(_components.strong, {
          children: "User"
        }), " object, you can add the condition ", _jsx(_components.code, {
          children: "IsActive"
        }), " ", _jsx(_components.strong, {
          children: "equals"
        }), " ", _jsx(_components.code, {
          children: "True"
        }), " so that Hightouch only matches active users."]
      }), "\n", _jsxs(_components.p, {
        children: ["To add a condition, click ", _jsx(_components.strong, {
          children: "Add condition"
        }), " below the lookup mapping, then select a Salesforce field and enter the value it must equal.\nYou can add multiple conditions; Hightouch requires matched records to satisfy all of them."]
      }), "\n", _jsxs(_components.p, {
        children: ["Unlike the lookup's match value, condition values are fixed values rather than model columns: Hightouch applies the same conditions to every row in the sync.\nEnter dates in ISO 8601 format, for example, ", _jsx(_components.code, {
          children: "2026-01-01"
        }), " for date fields or ", _jsx(_components.code, {
          children: "2026-01-01T00:00:00Z"
        }), " for datetime fields."]
      }), "\n", _jsx(_components.p, {
        children: "If a record matches the lookup field but doesn't satisfy every condition, Hightouch treats the lookup as not found and rejects the row, unless you've configured the lookup to sync a null value instead."
      }), "\n", _jsx(_components.h4, {
        id: "delete-behavior",
        children: "Delete behavior"
      }), "\n", _jsxs(_components.p, {
        children: ["The ", _jsx(_components.a, {
          href: "/syncs/overview#delete-behavior",
          children: "delete behavior"
        }), " you select dictates what to do when a row no longer appears in your model's query results. Depending on the ", _jsx(_components.a, {
          href: "#objects",
          children: "sync mode"
        }), " you're using, you can select from some or all of these options:"]
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Behavior"
            }), _jsx(_components.th, {
              children: "Description"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Do nothing"
              })
            }), _jsx(_components.td, {
              children: "Keep the record in Salesforce"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Clear fields"
              })
            }), _jsx(_components.td, {
              children: "Keep the record, but clear the mapped fields"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Delete record"
              })
            }), _jsx(_components.td, {
              children: "Delete the record in Salesforce"
            })]
          })]
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["In Upsert mode, you can select from all three. In Update mode, you can only select between ", _jsx(_components.strong, {
          children: "Do nothing"
        }), " and ", _jsx(_components.strong, {
          children: "Clear fields"
        }), ". Insert mode doesn't support delete behavior."]
      }), "\n", _jsx(Warning, {
        children: _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Delete record"
          }), " permanently deletes the Salesforce record when it leaves\nyour model's query results, and it can't be recovered through Hightouch.\nChoose ", _jsx(_components.strong, {
            children: "Clear fields"
          }), " instead if you only need to blank the mapped values."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "batching-and-parallelization",
        children: "Batching and parallelization"
      }), "\n", _jsx(_components.p, {
        children: "By default, Hightouch sends batches of 1,000 records to Salesforce and sends ten batches in parallel."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-salesforce-batch-parallelization.png",
          alt: "Batch and parallelization settings in the Hightouch UI"
        })
      }), "\n", _jsx(_components.p, {
        children: "You can increase the batch size up to 10,000 records per batch and parallelization up to 50 batches. Higher batch sizes and batch parallelization can increase the speed of your sync, but may eventually cause errors due to the amount of processing power they require from Salesforce."
      }), "\n", _jsxs(_components.p, {
        children: ["If you run into APEX errors such as ", _jsx(_components.code, {
          children: "TOO_MANY_APEX_REQUESTS"
        }), " it can be helpful to lower and tune these numbers. For example, you can decrease your batch size by half and if you no longer encounter errors, you can raise the batch size limit slowly."]
      }), "\n", _jsx(_components.h4, {
        id: "bulk-api-version",
        children: "Bulk API version"
      }), "\n", _jsxs(_components.p, {
        children: ["Two Bulk API versions are available: the legacy ", _jsx(_components.a, {
          href: "https://developer.salesforce.com/docs/atlas.en-us.api_asynch.meta/api_asynch/api_asynch_introduction_bulk_api.htm",
          children: "Bulk API"
        }), " (used by default) and ", _jsx(_components.a, {
          href: "https://developer.salesforce.com/docs/atlas.en-us.api_asynch.meta/api_asynch/bulk_api_2_0.htm",
          children: "Bulk API 2.0"
        }), ". Opt in to Bulk API 2.0 in the sync configuration."]
      }), "\n", _jsxs(_components.p, {
        children: ["The API versions have different batch and parallelization limits.\nSpecifically, the original Bulk API counts the number of calls and Bulk API 2.0 counts the number of records.\nYou can learn more about different limits and allocations between the two versions in ", _jsx(_components.a, {
          href: "https://developer.salesforce.com/docs/atlas.en-us.244.0.salesforce_app_limits_cheatsheet.meta/salesforce_app_limits_cheatsheet/salesforce_app_limits_platform_bulkapi.htm",
          children: "Salesforce's docs"
        }), ".\nYou should select the version that best suits your Salesforce agreement."]
      }), "\n", _jsxs(Info, {
        children: [_jsxs(_components.a, {
          href: "#objects",
          children: [_jsx(_components.strong, {
            children: "Insert"
          }), " mode"]
        }), " doesn't support Bulk API 2.0."]
      }), "\n", _jsx(_components.h4, {
        id: "rest-api-support",
        children: "REST API support"
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch provides the option to use Salesforce's ", _jsx(_components.a, {
          href: "https://developer.salesforce.com/docs/atlas.en-us.api_rest.meta/api_rest/intro_rest.htm",
          children: "REST API"
        }), " instead of the Bulk API. This can be useful if your account runs into usage limits with the Bulk API and has a higher usage limit for the REST API. You can enable the REST API in the ", _jsx(_components.code, {
          children: "Advanced"
        }), " section in your sync configuration."]
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch currently uses ", _jsx(_components.code, {
          children: "v58.0"
        }), " for the REST API."]
      }), "\n", _jsxs(_components.p, {
        children: ["The REST API uses a default batch size of 200 records per request. If you have automations that require specific batch sizes, you can adjust this in the ", _jsx(_components.code, {
          children: "Advanced"
        }), " settings configuration as well."]
      }), "\n", _jsx(_components.h4, {
        id: "split-retries",
        children: "Split retries"
      }), "\n", _jsxs(_components.p, {
        children: ["Salesforce return a ", _jsx(_components.code, {
          children: "200"
        }), " successful response even when part of a batch of updates failed.\nIn some cases, you may want to retry the failed records, like for the ", _jsxs(_components.a, {
          href: "#unable_to_lock_row",
          children: [_jsx(_components.code, {
            children: "UNABLE_TO_LOCK_ROW"
          }), " error"]
        }), ".\nYou can enable ", _jsx(_components.a, {
          href: "/syncs/retries#split-retries",
          children: _jsx(_components.strong, {
            children: "split retries"
          })
        }), " to filter out the records\nthat received the relevant errors and retry them again."]
      }), "\n", _jsx(_components.h4, {
        id: "merging-objects",
        children: "Merging objects"
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["You can only merge ", _jsx(_components.strong, {
            children: "Account"
          }), ", ", _jsx(_components.strong, {
            children: "Contact"
          }), ", ", _jsx(_components.strong, {
            children: "Individual"
          }), ", and ", _jsx(_components.strong, {
            children: "Lead"
          }), "\nobjects. Only ", _jsx(_components.a, {
            href: "#objects",
            children: "upsert and insert"
          }), " modes support merging, and you\nmust set ", _jsx(_components.a, {
            href: "#batching-and-parallelization",
            children: "parallelization"
          }), " to ", _jsx(_components.strong, {
            children: "1"
          }), "."]
        })
      }), "\n", _jsx(_components.p, {
        children: "If your model contains child records that should be merged into a parent record, Hightouch handles merging the records into their respective parents based on two fields:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.code, {
            children: "shared_id"
          })
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.code, {
            children: "merge_id"
          }), " or ", _jsx(_components.code, {
            children: "is_child"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch treats records with the same ", _jsx(_components.code, {
          children: "shared_id"
        }), " as the same record and merges them together.\nAll child records in a group with the same ", _jsx(_components.code, {
          children: "shared_id"
        }), " must have a ", _jsx(_components.code, {
          children: "merge_id"
        }), " or ", _jsx(_components.code, {
          children: "is_child"
        }), " field populated."]
      }), "\n", _jsx(_components.p, {
        children: "For example, suppose you have the following records in your model's query result:"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Account"
            }), _jsx(_components.th, {
              children: "Shared ID"
            }), _jsx(_components.th, {
              children: "Is child"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Account A"
            }), _jsx(_components.td, {
              children: "1"
            }), _jsx(_components.td, {
              children: "true"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Account B"
            }), _jsx(_components.td, {
              children: "1"
            }), _jsx(_components.td, {
              children: "true"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Account C"
            }), _jsx(_components.td, {
              children: "1"
            }), _jsx(_components.td, {
              children: "false"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Account D"
            }), _jsx(_components.td, {
              children: "2"
            }), _jsx(_components.td, {
              children: "false"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Account E"
            }), _jsx(_components.td, {
              children: "3"
            }), _jsx(_components.td, {
              children: "false"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Account F"
            }), _jsx(_components.td, {
              children: "3"
            }), _jsx(_components.td, {
              children: "true"
            })]
          })]
        })]
      }), "\n", _jsx(_components.p, {
        children: "Hightouch would merge Account A, Account B, and Account C together with Account C as the parent.\nAccounts E and F will be merged together with Account E as the parent."
      }), "\n", _jsx(_components.p, {
        children: "Select the appropriate model columns and corresponding Salesforce fields for this logic."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-salesforce-merge-objects.png",
          alt: "Merge settings in the Hightouch UI"
        })
      }), "\n", _jsx(_components.h4, {
        id: "multi-object-syncs",
        children: "Multi-object syncs"
      }), "\n", _jsxs(_components.p, {
        children: ["Sync to multiple objects, such as ", _jsx(_components.strong, {
          children: "Contact or Lead"
        }), " and ", _jsx(_components.strong, {
          children: "Account or Lead"
        }), ". Hightouch checks whether your ", _jsx(_components.strong, {
          children: "external ID mapping"
        }), " matches either object and updates the one it finds."]
      }), "\n", _jsxs(_components.p, {
        children: ["To use multi-object syncs, make sure that your Lead's external ID field is ", _jsx(_components.strong, {
          children: "mapped"
        }), " to the matching field on your Contact or Account. You can check by following these steps."]
      }), "\n", _jsxs(_components.ol, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Find the ", _jsx(_components.strong, {
              children: "Lead"
            }), " in the Salesforce ", _jsx(_components.strong, {
              children: "Object Manager"
            }), ". Refer to the above documentation for information on ", _jsx(_components.a, {
              href: "#inspect-objects-relationships-and-fields",
              children: "how to use and access the Object Manager"
            }), "."]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Go to ", _jsx(_components.strong, {
              children: "Fields & Relationships"
            }), "."]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Click ", _jsx(_components.strong, {
              children: "Map Lead Field"
            }), "."]
          }), "\n", _jsx(_components.p, {
            children: _jsx(_components.img, {
              src: "destinations/destination-salesforce-multi-object-fields-and-relationships.png",
              alt: "Mapping Lead Fields in the Salesforce UI"
            })
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "Map your Lead's external ID to the matching field on the Contact or Account."
          }), "\n", _jsx(_components.p, {
            children: _jsx(_components.img, {
              src: "destinations/destination-salesforce-multi-object-mapping.png",
              alt: "Mapping Lead Fields in the Salesforce UI"
            })
          }), "\n"]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: "You may also map other fields that you want to carry over from Leads when they're converted."
      }), "\n", _jsx(_components.h4, {
        id: "salesforce-person-accounts-syncs",
        children: "Salesforce person accounts syncs"
      }), "\n", _jsxs(_components.p, {
        children: ["If you need to send data to a Salesforce ", _jsx(_components.a, {
          href: "https://help.salesforce.com/s/articleView?id=sf.account_person.htm&type=5",
          children: "person account"
        }), ", follow these steps:"]
      }), "\n", _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "Contact Salesforce to enable person accounts if they aren't already."
        }), "\n", _jsxs(_components.li, {
          children: ["In your Hightouch sync configuration, select ", _jsx(_components.strong, {
            children: "Account"
          }), " as the object to sync data to. A person account is a copy of the account object."]
        }), "\n", _jsxs(_components.li, {
          children: ["Select your desired ", _jsx(_components.a, {
            href: "#objects",
            children: "sync mode"
          }), "."]
        }), "\n", _jsxs(_components.li, {
          children: ["Ensure you map at least a ", _jsx(_components.strong, {
            children: "LastName"
          }), " field instead of ", _jsx(_components.strong, {
            children: "FullName"
          }), ". Without this level of specificity, the sync fails."]
        }), "\n", _jsx(_components.li, {
          children: "Complete your configuration as usual."
        }), "\n"]
      }), "\n", _jsx(_components.h3, {
        id: "custom-picklist-values",
        children: "Custom picklist values"
      }), "\n", _jsx(_components.p, {
        children: "Update the values of a custom picklist field on any object. Create a separate sync configuration for each picklist, even when the picklists are on the same object."
      }), "\n", _jsxs(_components.p, {
        children: ["When syncing custom picklist values, ", _jsx(_components.em, {
          children: "all active picklist values"
        }), " are ", _jsx(_components.strong, {
          children: "replaced"
        }), " with each sync. For example, if your model returns four records, all four records become values for your picklist. Hightouch doesn't check which values are already there or append the new values. Each sync completes overwrites existing picklist values."]
      }), "\n", _jsx(_components.p, {
        children: "First, select the object whose picklist you want to update, then specify the picklist whose values you wish to update:"
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-salesforce-picklists-sync-configuration.png",
          alt: "Picklist configuration in the Hightouch UI"
        })
      }), "\n", _jsx(_components.h4, {
        id: "record-matching-1",
        children: "Record matching"
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch matches rows from your model to picklist values on the values' ", _jsx(_components.strong, {
          children: "API name"
        }), ", also referred to as ", _jsx(_components.code, {
          children: "valueName"
        }), ". Select the model column that includes the appropriate API names for matching. API names must be unique across both inactive and active values within a picklist."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-salesforce-picklists-record-matching.png",
          alt: "Picklist configuration in the Hightouch UI"
        })
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping-1",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "You can optionally select a model column that custom labels. Label values must be unique amongst active values in a picklist."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-salesforce-picklists-field-mappings.png",
          alt: "Picklist configuration in the Hightouch UI"
        })
      }), "\n", _jsx(_components.h4, {
        id: "limitations",
        children: "Limitations"
      }), "\n", _jsxs(_components.p, {
        children: ["Custom picklists may only contain a ", _jsx(_components.strong, {
          children: "total of 1000 values"
        }), " (active and inactive) per picklist."]
      }), "\n", _jsx(_components.h3, {
        id: "platform-events",
        children: "Platform events"
      }), "\n", _jsx(_components.p, {
        children: "Salesforce platform events are immutable, which means that you cannot update or delete them after they have been published. As a result, platform event syncs always use insert mode. This means that Hightouch ignores row changes and removals in your model's query results, and publishes a new platform event whenever a new row appears in your model results."
      }), "\n", _jsx(EventSyncWarning, {}), "\n", _jsx(_components.p, {
        children: "Before events appear in your Hightouch sync configuration, you first need to create platform events in your Salesforce instance. Hightouch then surfaces them within the sync configuration in a dropdown."
      }), "\n", _jsx(_components.h4, {
        id: "record-matching-2",
        children: "Record matching"
      }), "\n", _jsxs(_components.p, {
        children: ["Since platform events are ", _jsx(_components.strong, {
          children: "Insert"
        }), " only, you don't need to match them to existing records."]
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping-2",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "Hightouch doesn't create platform event fields — create every field you need on the event in Salesforce first, then map your source columns to them."
      }), "\n", _jsx(_components.h2, {
        id: "tips-and-troubleshooting",
        children: "Tips and troubleshooting"
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["For Hightouch platform error codes related to Salesforce, see ", _jsx(_components.a, {
            href: "/developer-tools/error-codes#salesforce",
            children: "Error codes:\nSalesforce"
          }), "."]
        })
      }), "\n", _jsx(_components.h3, {
        id: "behavior-and-limitations",
        children: "Behavior and limitations"
      }), "\n", _jsx(_components.h4, {
        id: "sandbox-versions",
        children: "Sandbox versions"
      }), "\n", _jsxs(_components.p, {
        children: ["Older Salesforce sandbox versions can cause processing delays or errors. If you sync to a sandbox and hit these, check its version and upgrade if needed. See ", _jsx(_components.a, {
          href: "https://help.salesforce.com/s/articleView?id=sf.data_sandbox_environments.htm&type=5",
          children: "Salesforce Sandbox Licenses and Storage Limits by Type"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "enhanced-domains-require-reauthorization",
        children: "Enhanced domains require reauthorization"
      }), "\n", _jsxs(_components.p, {
        children: ["Enabling ", _jsx(_components.a, {
          href: "https://help.salesforce.com/s/articleView?id=sf.domain_name_enhanced.htm&language=en_US&type=5",
          children: "enhanced domains"
        }), " changes your Salesforce instance URL, so you must ", _jsx(_components.a, {
          href: "#connect-to-salesforce",
          children: "reauthorize"
        }), " the destination or syncs break. Go to your Salesforce destination configuration and select ", _jsx(_components.strong, {
          children: "Log in to Salesforce"
        }), " under ", _jsx(_components.strong, {
          children: "Reauthorize connection"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-salesforce-reauthorization.png",
          alt: "Reauthorizing the Salesforce connection in the Hightouch UI"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["To learn more, see ", _jsx(_components.a, {
          href: "https://help.salesforce.com/s/articleView?id=000393816&type=1",
          children: "Salesforce's enhanced domain FAQ"
        }), "."]
      }), "\n", _jsx(_components.h3, {
        id: "sync-volume-and-performance",
        children: "Sync volume and performance"
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch can process millions of rows to Salesforce in a single sync, given you have the available Salesforce API calls. In other words, sync volume limitations are a factor of your ", _jsx(_components.a, {
          href: "https://developer.salesforce.com/docs/atlas.en-us.salesforce_app_limits_cheatsheet.meta/salesforce_app_limits_cheatsheet/salesforce_app_limits_platform_api.htm",
          children: "Salesforce API request limits and allocations"
        }), ", rather than Hightouch. If you're syncing large volumes of data, you may want to finetune your ", _jsx(_components.a, {
          href: "#batching-and-parallelization",
          children: "batching and parallelization configuration"
        }), " for optimal performance."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.a, {
          href: "#objects",
          children: "Upsert mode"
        }), " calls Salesforce's upsert endpoint, which can improve sync performance and lower API datapoint consumption since it only requires one single API request per batch of rows. However, there are still some additional API calls for ", _jsx(_components.a, {
          href: "/syncs/retries",
          children: "rejected row retries"
        }), " and miscellaneous data that needs to be sent to Salesforce. This efficient Upsert mode only works when the Salesforce field used for record matching is an ", _jsx(_components.a, {
          href: "#record-matching",
          children: "explicit external ID field"
        }), "."]
      }), "\n", _jsx(_components.h3, {
        id: "validate-your-setup",
        children: "Validate your setup"
      }), "\n", _jsx(_components.p, {
        children: "After your first sync completes, confirm the data landed in Salesforce:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Objects:"
          }), " open the target object in ", _jsx(_components.strong, {
            children: "Object Manager"
          }), " or a list view, find a synced record, and check that the mapped fields hold the expected values."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Custom picklist values:"
          }), " open the picklist field's definition and confirm the active values match your model."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Platform events:"
          }), " confirm a subscribed flow, process, or Apex trigger fired, or find the event in Salesforce's debug logs."]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["If a sync errors, open the sync run log for the exact Salesforce API message and match it against ", _jsx(_components.a, {
          href: "#common-errors",
          children: "Common errors"
        }), "."]
      }), "\n", _jsx(_components.h3, {
        id: "common-errors",
        children: "Common errors"
      }), "\n", _jsx(CommonErrorsPreface, {}), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              align: "left",
              children: "Error message"
            }), _jsx(_components.th, {
              align: "left",
              children: "Description"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.code, {
                children: "ApiBatchItems Limit exceeded."
              })
            }), _jsxs(_components.td, {
              align: "left",
              children: ["Daily Bulk API limit exceeded. ", _jsx(_components.a, {
                href: "#apibatchitems-limit-exceeded",
                children: "More detail."
              })]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.code, {
                children: "CANNOT_UPDATE_CONVERTED_LEAD"
              })
            }), _jsxs(_components.td, {
              align: "left",
              children: ["Attempting to update a converted lead. ", _jsx(_components.a, {
                href: "#cannot_update_converted_lead",
                children: "More detail."
              })]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.code, {
                children: "DUPLICATE_EXTERNAL_ID"
              })
            }), _jsxs(_components.td, {
              align: "left",
              children: ["Duplicate IDs in external data. ", _jsx(_components.a, {
                href: "#duplicate_external_id",
                children: "More detail."
              })]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.code, {
                children: "DUPLICATES_DETECTED"
              })
            }), _jsxs(_components.td, {
              align: "left",
              children: ["Duplicate records in a sync batch. ", _jsx(_components.a, {
                href: "#duplicates_detected",
                children: "More detail."
              })]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.code, {
                children: "INSUFFICIENT_ACCESS_ON_CROSS_REFERENCE_ENTITY"
              })
            }), _jsxs(_components.td, {
              align: "left",
              children: ["Missing access to a cross-referenced object. ", _jsx(_components.a, {
                href: "#insufficient_access_on_cross_reference_entity",
                children: "More detail."
              })]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.code, {
                children: "INSUFFICIENT_ACCESS_OR_READONLY"
              })
            }), _jsxs(_components.td, {
              align: "left",
              children: ["Missing object or field permissions. ", _jsx(_components.a, {
                href: "#insufficient_access_or_readonly",
                children: "More detail."
              })]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.code, {
                children: "INVALID_CROSS_REFERENCE_KEY"
              })
            }), _jsxs(_components.td, {
              align: "left",
              children: ["Referenced record ID doesn't exist or is inaccessible. ", _jsx(_components.a, {
                href: "#invalid_cross_reference_key",
                children: "More detail."
              })]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.code, {
                children: "INVALID_FIELD_FOR_INSERT_UPDATE"
              })
            }), _jsxs(_components.td, {
              align: "left",
              children: ["Writing to a non-editable field. ", _jsx(_components.a, {
                href: "#invalid_field_for_insert_update",
                children: "More detail."
              })]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.code, {
                children: "INVALID_OR_NULL_FOR_RESTRICTED_PICKLIST"
              })
            }), _jsxs(_components.td, {
              align: "left",
              children: ["Invalid value for a restricted picklist. ", _jsx(_components.a, {
                href: "#invalid_or_null_for_restricted_picklist",
                children: "More detail."
              })]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.code, {
                children: "INVALID_TYPE_ON_FIELD_IN_RECORD"
              })
            }), _jsxs(_components.td, {
              align: "left",
              children: ["Type mismatch on a field value. ", _jsx(_components.a, {
                href: "#invalid_type_on_field_in_record",
                children: "More detail."
              })]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.code, {
                children: "OAUTH_APP_BLOCKED"
              })
            }), _jsxs(_components.td, {
              align: "left",
              children: ["Hightouch OAuth app blocked in Salesforce. ", _jsx(_components.a, {
                href: "#oauth_app_blocked",
                children: "More detail."
              })]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.code, {
                children: "UNABLE_TO_LOCK_ROW"
              })
            }), _jsxs(_components.td, {
              align: "left",
              children: ["Concurrent processes locking the same record. ", _jsx(_components.a, {
                href: "#unable_to_lock_row",
                children: "More detail."
              })]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.code, {
                children: "ValidationError: Reference not found"
              })
            }), _jsxs(_components.td, {
              align: "left",
              children: ["Lookup mapping references a nonexistent value. ", _jsx(_components.a, {
                href: "#validationerror-reference-not-found",
                children: "More detail."
              })]
            })]
          })]
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["See Salesforce's comprehensive ", _jsx(_components.a, {
          href: "https://developer.salesforce.com/docs/atlas.en-us.api.meta/api/sforce_api_calls_concepts_core_data_objects.htm#i1421192",
          children: "list of error messages and error codes"
        }), " for more."]
      }), "\n", "\n", _jsx(_components.h4, {
        id: "apibatchitems-limit-exceeded",
        children: "ApiBatchItems Limit exceeded"
      }), "\n", "\n", _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "hljs",
          children: "ApiBatchItems Limit exceeded.\n"
        })
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Cause:"
        }), " Your Salesforce org has used up its daily ApiBatchItems Bulk API limit."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Solution:"
        }), " Check your ", _jsx(_components.a, {
          href: "https://developer.salesforce.com/docs/atlas.en-us.salesforce_app_limits_cheatsheet.meta/salesforce_app_limits_cheatsheet/salesforce_app_limits_platform_bulkapi.htm",
          children: "Salesforce Bulk API limits"
        }), ", review any other high-volume jobs running against the org, and retry the sync after the limit resets."]
      }), "\n", "\n", _jsx(_components.h4, {
        id: "cannot_update_converted_lead",
        children: "CANNOT_UPDATE_CONVERTED_LEAD"
      }), "\n", "\n", _jsx(_components.pre, {
        children: _jsxs(_components.code, {
          className: "hljs language-objectivec",
          children: [_jsx(_components.span, {
            className: "hljs-built_in",
            children: "CANNOT_UPDATE_CONVERTED_LEAD"
          }), "\n"]
        })
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Cause:"
        }), " The sync is attempting to update a lead that has been ", _jsx(_components.a, {
          href: "https://help.salesforce.com/s/articleView?id=sf.leads_convert.htm&type=5",
          children: "converted"
        }), " into a contact, account, or opportunity. Once converted, the lead record becomes read-only in Salesforce — it still exists in the Leads object but can no longer be updated."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.strong, {
          children: "Solution:"
        })
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["Filter converted leads out of your model's query results. In Salesforce, the ", _jsx(_components.code, {
            children: "IsConverted"
          }), " field on the Lead object indicates whether a lead has been converted."]
        }), "\n", _jsx(_components.li, {
          children: "If you need to update the resulting records, sync to the Contact, Account, or Opportunity object instead."
        }), "\n"]
      }), "\n", "\n", _jsx(_components.h4, {
        id: "duplicate_external_id",
        children: "DUPLICATE_EXTERNAL_ID"
      }), "\n", "\n", _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "hljs",
          children: "DUPLICATE_EXTERNAL_ID\n"
        })
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Cause:"
        }), " Records with the same IDs are coming from an external system. This can happen when a lead or contact was imported with the wrong External CRM ID, when you have null values in your primary key, or when the Salesforce field used for record matching contains duplicates."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Solution:"
        }), " Deduplicate your model's query results and ensure the field used for ", _jsx(_components.a, {
          href: "#record-matching",
          children: "record matching"
        }), " contains unique, non-null values. In Salesforce, verify the external ID field doesn't already contain duplicate values."]
      }), "\n", "\n", _jsx(_components.h4, {
        id: "duplicates_detected",
        children: "DUPLICATES_DETECTED"
      }), "\n", "\n", _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "hljs",
          children: "DUPLICATES_DETECTED\n"
        })
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Cause:"
        }), " The sync batch contains duplicate records. This can happen when you have null values in your primary key or when the Salesforce field used for record matching contains duplicates."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Solution:"
        }), " Ensure your model doesn't return duplicated rows. Check that the field used for ", _jsx(_components.a, {
          href: "#record-matching",
          children: "record matching"
        }), " contains unique, non-null values."]
      }), "\n", "\n", _jsx(_components.h4, {
        id: "insufficient_access_on_cross_reference_entity",
        children: "INSUFFICIENT_ACCESS_ON_CROSS_REFERENCE_ENTITY"
      }), "\n", "\n", _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "hljs",
          children: "INSUFFICIENT_ACCESS_ON_CROSS_REFERENCE_ENTITY\n"
        })
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Cause:"
        }), " The connected Salesforce user doesn't have sufficient access to a related record referenced in a lookup or relationship field."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Solution:"
        }), " Check that the connected Salesforce user has access to the object being cross-referenced in your sync. Review ", _jsx(_components.a, {
          href: "https://help.salesforce.com/s/articleView?id=sf.users_profiles_fls.htm&type=5",
          children: "field-level security"
        }), ", ", _jsx(_components.a, {
          href: "https://help.salesforce.com/s/articleView?id=sf.security_sharing_rules.htm&type=5",
          children: "sharing rules"
        }), ", and record ownership for the referenced records."]
      }), "\n", "\n", _jsx(_components.h4, {
        id: "insufficient_access_or_readonly",
        children: "INSUFFICIENT_ACCESS_OR_READONLY"
      }), "\n", "\n", _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "hljs",
          children: "INSUFFICIENT_ACCESS_OR_READONLY\n"
        })
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Cause:"
        }), " The Salesforce user connected to Hightouch lacks the required object-level or field-level permissions for the records being synced. This error can appear intermittently when some records in a batch require access that the user doesn't have."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.strong, {
          children: "Solution:"
        })
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["Verify that the connected Salesforce user's profile has ", _jsx(_components.strong, {
            children: "read and write access"
          }), " to the object being synced. Go to ", _jsx(_components.strong, {
            children: "Setup → Profiles"
          }), " or ", _jsx(_components.strong, {
            children: "Setup → Permission Sets"
          }), " in Salesforce and check the ", _jsx(_components.a, {
            href: "https://help.salesforce.com/s/articleView?id=sf.perm_sets_object_perms_edit.htm&type=5",
            children: "object permissions"
          }), "."]
        }), "\n", _jsxs(_components.li, {
          children: ["Check ", _jsx(_components.a, {
            href: "https://help.salesforce.com/s/articleView?id=sf.users_profiles_fls.htm&type=5",
            children: "field-level security"
          }), " for the specific fields in your sync mapping. The connected user must have write access to every mapped field, not just the object."]
        }), "\n", _jsxs(_components.li, {
          children: ["If the error appears only for specific records, look for ", _jsx(_components.a, {
            href: "https://help.salesforce.com/s/articleView?id=sf.security_sharing_rules.htm&type=5",
            children: "record-level sharing rules"
          }), ", ownership restrictions, or org-wide defaults that may limit access to those records."]
        }), "\n"]
      }), "\n", "\n", _jsx(_components.h4, {
        id: "invalid_cross_reference_key",
        children: "INVALID_CROSS_REFERENCE_KEY"
      }), "\n", "\n", _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "hljs",
          children: "INVALID_CROSS_REFERENCE_KEY\n"
        })
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Cause:"
        }), " The sync is attempting to create or update a record that references a nonexistent or inaccessible record ID in a lookup or relationship field. Common causes include syncing IDs from a different Salesforce object, a different org (production vs. sandbox), or referencing records that have been deleted."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.strong, {
          children: "Solution:"
        })
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Verify that the referenced record IDs in your model exist in the target Salesforce org. IDs don't carry over between sandbox and production environments."
        }), "\n", _jsx(_components.li, {
          children: "Check that the connected Salesforce user has access to the referenced records. Record-level sharing rules or org-wide defaults can restrict visibility."
        }), "\n", _jsx(_components.li, {
          children: "Ensure lookup fields reference the correct object type — for example, an Account ID in a field that expects a Contact ID triggers this error."
        }), "\n"]
      }), "\n", "\n", _jsx(_components.h4, {
        id: "invalid_field_for_insert_update",
        children: "INVALID_FIELD_FOR_INSERT_UPDATE"
      }), "\n", "\n", _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "hljs",
          children: "INVALID_FIELD_FOR_INSERT_UPDATE\n"
        })
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Cause:"
        }), " The sync is attempting to write to a field that Salesforce doesn't allow to be inserted or updated. Salesforce has several non-editable field types that reject writes regardless of user permissions: formula fields, roll-up summary fields, auto-number fields, and system-managed fields like Created By, Created Date, Last Modified By, and Last Modified Date."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.strong, {
          children: "Solution:"
        })
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["Open the ", _jsx(_components.a, {
            href: "#inspect-objects-relationships-and-fields",
            children: "Object Manager"
          }), " in Salesforce and verify that each mapped field is editable — not a formula, auto-number, roll-up summary, or system-managed field."]
        }), "\n", _jsxs(_components.li, {
          children: ["Check ", _jsx(_components.a, {
            href: "https://help.salesforce.com/s/articleView?id=sf.users_profiles_fls.htm&type=5",
            children: "field-level security"
          }), " for the connected user's profile to confirm write access on every mapped field."]
        }), "\n", _jsxs(_components.li, {
          children: ["If you're using ", _jsx(_components.a, {
            href: "https://help.salesforce.com/s/articleView?id=sf.user_recordtype.htm&type=5",
            children: "record types"
          }), ", ensure a default record type is assigned to the connected user's profile. A missing default record type can trigger this error on insert operations."]
        }), "\n", _jsx(_components.li, {
          children: "If you need the data in a non-editable field, create a custom editable field on the same object and sync to that instead. You can then use Salesforce automation (flows or Apex triggers) to copy the value where needed."
        }), "\n"]
      }), "\n", "\n", _jsx(_components.h4, {
        id: "invalid_or_null_for_restricted_picklist",
        children: "INVALID_OR_NULL_FOR_RESTRICTED_PICKLIST"
      }), "\n", "\n", _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "hljs",
          children: "INVALID_OR_NULL_FOR_RESTRICTED_PICKLIST\n"
        })
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Cause:"
        }), " The sync is attempting to write an invalid value into a restricted picklist field — for example, a value that isn't in the picklist's allowed values, a value that exceeds the field's length limit, or a data type mismatch."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Solution:"
        }), " Review the picklist field's settings in Salesforce (", _jsx(_components.strong, {
          children: "Setup → Object Manager → [Object] → Fields & Relationships → [Field]"
        }), ") and ensure the values in your model match the allowed picklist values exactly, including casing."]
      }), "\n", "\n", _jsx(_components.h4, {
        id: "invalid_type_on_field_in_record",
        children: "INVALID_TYPE_ON_FIELD_IN_RECORD"
      }), "\n", "\n", _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "hljs",
          children: "INVALID_TYPE_ON_FIELD_IN_RECORD\n"
        })
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Cause:"
        }), " The sync is sending a value with an incompatible type — most commonly a ", _jsx(_components.code, {
          children: "null"
        }), " value to a Boolean field. This error can also occur when a ", _jsx(_components.a, {
          href: "https://help.salesforce.com/s/articleView?id=sf.flow_concepts_trigger_record.htm&type=5",
          children: "before-save update flow"
        }), " sets a value that conflicts with the value sent from Hightouch."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Solution:"
        }), " Ensure your model doesn't send ", _jsx(_components.code, {
          children: "null"
        }), " to Boolean fields in Salesforce. If a before-save flow is conflicting, disable or modify the flow."]
      }), "\n", "\n", _jsx(_components.h4, {
        id: "oauth_app_blocked",
        children: "OAUTH_APP_BLOCKED"
      }), "\n", "\n", _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "hljs",
          children: "OAUTH_APP_BLOCKED\n"
        })
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Cause:"
        }), " The Hightouch connected app is blocked in Salesforce."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.strong, {
          children: "Solution:"
        })
      }), "\n", _jsxs(_components.ol, {
        children: ["\n", _jsxs(_components.li, {
          children: ["Go to ", _jsx(_components.strong, {
            children: "Setup → Connected Apps OAuth Usage"
          }), " in Salesforce and ensure Hightouch is unblocked. The user verifying OAuth permissions must be a Salesforce admin."]
        }), "\n", _jsx(_components.li, {
          children: "Grant Hightouch read and write access to all the objects and fields you intend to sync."
        }), "\n", _jsxs(_components.li, {
          children: ["Ensure the connected user's profile has the ", _jsx(_components.strong, {
            children: "View Setup and Configuration"
          }), " permission enabled under ", _jsx(_components.strong, {
            children: "Administrative Permissions"
          }), "."]
        }), "\n"]
      }), "\n", "\n", _jsx(_components.h4, {
        id: "unable_to_lock_row",
        children: "UNABLE_TO_LOCK_ROW"
      }), "\n", "\n", _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "hljs",
          children: "UNABLE_TO_LOCK_ROW\n"
        })
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Cause:"
        }), " Multiple processes — including Hightouch syncs — are trying to modify the same record at the same time. Salesforce can't work on a row while another process is touching it."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.strong, {
          children: "Solution:"
        })
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["If there is an ", _jsx(_components.a, {
            href: "#inspect-apex-triggers-and-flows",
            children: "Apex trigger or workflow"
          }), " that conflicts with your sync, pause the process or rerun the sync after the process finishes. This error is often temporary and resolves on retry."]
        }), "\n", _jsxs(_components.li, {
          children: ["Lower your ", _jsx(_components.a, {
            href: "#batching-and-parallelization",
            children: "parallelization"
          }), " to five or less to minimize the chances of two requests modifying the same record simultaneously."]
        }), "\n", _jsx(_components.li, {
          children: "Identify long-running processes in your Salesforce environment that could be holding locks. Optimize them or break them into smaller batches."
        }), "\n", _jsxs(_components.li, {
          children: ["Ensure your ", _jsx(_components.a, {
            href: "/getting-started/concepts#models",
            children: "model"
          }), " doesn't return duplicated rows — duplicates can also trigger this error."]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["See ", _jsx(_components.a, {
          href: "https://help.salesforce.com/s/articleView?id=000387767&type=1",
          children: "Salesforce's Help Center"
        }), " for more information."]
      }), "\n", "\n", _jsx(_components.h4, {
        id: "validationerror-reference-not-found",
        children: "ValidationError: Reference not found"
      }), "\n", "\n", _jsx(_components.pre, {
        children: _jsxs(_components.code, {
          className: "hljs language-makefile",
          children: [_jsx(_components.span, {
            className: "hljs-section",
            children: "ValidationError: Reference not found"
          }), "\n"]
        })
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Cause:"
        }), " A ", _jsx(_components.a, {
          href: "#relationships-object-id-lookup",
          children: "relationship lookup mapping"
        }), " in the sync configuration can't find the referenced value in Salesforce. The error message contains the Salesforce field name used for the lookup and the value that failed."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Solution:"
        }), " Ensure the model column used for the lookup mapping only contains values that already exist in Salesforce. Check for typos, deleted records, or ID mismatches."]
      }), "\n", _jsx(_components.h3, {
        id: "missing-or-non-updating-fields-in-sync-configuration",
        children: "Missing or non-updating fields in sync configuration"
      }), "\n", _jsx(_components.p, {
        children: "If fields are missing from the sync configuration dropdown, or mapped fields aren't updating in Salesforce, check the following:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Field-level security (FLS):"
          }), " Go to ", _jsx(_components.strong, {
            children: "Setup → Object Manager → [Object] → Fields & Relationships"
          }), " in Salesforce and verify that the connected user's profile has read and write access to each field. FLS restrictions can silently prevent fields from appearing in Hightouch or prevent updates from landing."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Refresh fields:"
          }), " If you recently added or changed fields in Salesforce, go to your sync configuration in Hightouch and select ", _jsx(_components.strong, {
            children: "Refresh"
          }), " next to the destination field dropdown to pull the latest schema."]
        }), "\n", _jsx(_components.li, {
          children: "Ensure fields you want to match against are set as external identifiers."
        }), "\n", _jsx(_components.li, {
          children: "If you authenticated with your personal user ID, make sure you have permission to view and update the fields you want."
        }), "\n", _jsxs(_components.li, {
          children: ["If you're missing the Salesforce ID field for matching on, make sure you're in the correct sync mode. Matching on Salesforce ID ", _jsx(_components.a, {
            href: "#supported-syncing",
            children: "isn't supported for upserting"
          }), "—use update mode instead."]
        }), "\n", _jsxs(_components.li, {
          children: ["If you set your sync to ", _jsx(_components.a, {
            href: "#objects",
            children: "Update mode"
          }), ", the ", _jsx(_components.a, {
            href: "#field-mapping",
            children: "field mapping"
          }), " section only lists ", _jsx(_components.a, {
            href: "https://developer.salesforce.com/docs/atlas.en-us.uiapi.meta/uiapi/ui_api_responses_field.htm",
            children: _jsx(_components.code, {
              children: "updateable"
            })
          }), " Salesforce fields."]
        }), "\n", _jsx(_components.li, {
          children: "Verify that field names in your model still match Salesforce. If a field was renamed or deleted in Salesforce, the mapping breaks silently."
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["When syncing to multi-objects, for example, ", _jsx(_components.strong, {
          children: "Contact or Lead"
        }), " or ", _jsx(_components.strong, {
          children: "Account or Lead"
        }), ", ensure ", _jsx(_components.em, {
          children: "both"
        }), " object types include a shared unique field marked as a ", _jsx(_components.a, {
          href: "https://help.salesforce.com/s/articleView?id=000385174&type=1",
          children: _jsx(_components.code, {
            children: "Unique ID"
          })
        }), " or a unique ", _jsx(_components.code, {
          children: "external ID"
        }), ". Without meeting this requirement, you won't see any fields populate for record matching."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-salesforce-record-match.png",
          alt: "Record matching on multi-objects in the Hightouch UI"
        })
      }), "\n", _jsx(_components.h3, {
        id: "duplicate-records-in-salesforce",
        children: "Duplicate records in Salesforce"
      }), "\n", _jsxs(_components.p, {
        children: ["Make sure that the Salesforce field used for record matching is an ", _jsx(_components.strong, {
          children: "explicit external ID"
        }), " field. You can learn more about this in the ", _jsx(_components.a, {
          href: "#record-matching",
          children: "record matching"
        }), " section."]
      }), "\n", _jsx(_components.h3, {
        id: "live-debugger",
        children: "Live debugger"
      }), "\n", _jsx(LiveDebugger, {}), "\n", _jsxs(Info, {
        children: ["The debugger isn't available for ", _jsx(_components.strong, {
          children: "All"
        }), " and ", _jsx(_components.strong, {
          children: "Insert"
        }), " sync modes."]
      }), "\n", _jsx(_components.h3, {
        id: "sync-alerts",
        children: "Sync alerts"
      }), "\n", _jsx(SyncAlerts, {})]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
